import React, { Fragment, Component } from "react";
import SubHeader from "./SubHeader";
import StaffLinkPageActions from "./StaffLinkPageActions";
import { connect } from "react-redux";
import * as actions from "../../actions/users/getUserActions";
import { bindActionCreators } from "redux";
import { createNotification, NOTIFICATION_TYPE_SUCCESS } from 'react-redux-notify';

class StaffReportLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectCount: 0,
            exportTOExcel: 0,
            subHeaderItems: [
                {
                    name: "Staff Linking",
                    url: ""
                },
                {
                    name: "Client Linking",
                    url: ""
                },
            ]
        };
    }


    toggleBulkEditForm() {
        this.setState({
            shouldModalOpen: !this.state.shouldModalOpen
        });
    }

    render() {
        let len = this.props.staffReportDetails;
        return (
            <Fragment>
                <SubHeader subHeaderMenuItems={this.state.subHeaderItems} showClose={false} />
                <StaffLinkPageActions
                    reqClass={true ? "data_header--with_action" : "data_header"}
                />
            </Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        isModalOpen: state.userReducer.isModalOpen,
        staffReportDetails: state.userReducer.staffReportDetails

    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    createNotification: (config) => {
        dispatch(createNotification(config))
    },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffReportLayout);
